import {get, post} from "../util/http.service";

export const getOrders = () => get("/subscriptions/orders",);

export const createCheckoutSession = () => post("/subscriptions/checkout", {});
